// extracted by mini-css-extract-plugin
export default {"tiles":"tiles___vC__j","tile":"tile__ydv2tz","active":"active__BDRylK","icon":"icon__OLNmKt","tileText":"tileText__zEgrDJ","tileContent":"tileContent__LpEmG2"};